import { render, staticRenderFns } from "./RestaurantInfo.vue?vue&type=template&id=cc6390fa&"
import script from "./RestaurantInfo.vue?vue&type=script&lang=ts&"
export * from "./RestaurantInfo.vue?vue&type=script&lang=ts&"
import style0 from "./RestaurantInfo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports